import { createSelector } from 'reselect'

export const getCurrentGroup = createSelector(
  (state) => state && state.groups && state.groups.currentGroup ? state.groups.currentGroup : null,
  (group) => group
)
